import { render, staticRenderFns } from "./NonConformityCreateUpdate.vue?vue&type=template&id=49730990&scoped=true&"
import script from "./NonConformityCreateUpdate.vue?vue&type=script&lang=js&"
export * from "./NonConformityCreateUpdate.vue?vue&type=script&lang=js&"
import style0 from "./NonConformityCreateUpdate.vue?vue&type=style&index=0&id=49730990&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49730990",
  null
  
)

export default component.exports